// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"223":"65922800","488":"d3b7cd3a"}[chunkId] + ".chunk.js");